// Central editable configuration for DMEDIA CLUB.
export const CONTACT = {
  phoneDisplay: "(407) 445-8170",
  phoneLink: "tel:+14074458170",
  whatsappNumber: "14074458170",
  whatsappBase: "https://wa.me/14074458170",
  email: "infodmediaclub@gmail.com",
  emailLink: "mailto:infodmediaclub@gmail.com",
  addressLine1: "6536 Carrier Dr",
  addressLine2: "Orlando, FL 32819",
  instagram: "https://instagram.com/",
};

export const IMAGES = {
  hero: "/img/hero.webp",
  classroom: "/img/classroom.webp",
  openfloor: "/img/openfloor.webp",
  movement: "/img/movement.webp",
  empty: "/img/empty.webp",
  manifesto: "/img/openfloor.webp",
  coffee: "/img/coffee.webp",
  logo: "/dmedia-logo.png",
};

export const PRICING = {
  standard: [
    { label: "1 Hour", price: "$75", sub: "Weekday daytime only · Mon–Fri before 5pm" },
    { label: "2 Hours", price: "$130" },
    { label: "3 Hours", price: "$175" },
    { label: "Additional Hour", price: "$55" },
  ],
  experience: { price: "$250", label: "Two Hours" },
  openingOffer: { price: "$125", regular: "$175", hours: "3 Hours" },
  founding: { price: "$600", regular: "$700" },
};

export function waNumberLink(message) {
  return `${CONTACT.whatsappBase}?text=${encodeURIComponent(message)}`;
}

export const USE_OPTIONS = [
  "Workshop or Class",
  "Movement or Private Class",
  "Curated Brand Experience",
];

export const DURATION_BY_USE = {
  "Workshop or Class": ["1 hour", "2 hours", "3 hours", "More than 3 hours"],
  "Movement or Private Class": ["1 hour", "2 hours", "3 hours", "More than 3 hours"],
  "Curated Brand Experience": ["2 hours", "3 hours", "4 hours", "Custom duration"],
};
